export const REQUEST_STATE_READY = 'REQUEST_STATE_READY';
export const REQUEST_STATE_REQUESTING = 'REQUEST_STATE_REQUESTING';
export const REQUEST_STATE_ABORTED = 'REQUEST_STATE_ABORTED';
export const REQUEST_STATE_FAILED = 'REQUEST_STATE_FAILED';
export const REQUEST_STATE_SUCCEEDED = 'REQUEST_STATE_SUCCEEDED';

export const AUTH_STATE_UNKNOWN = 'AUTH_STATE_UNKNOWN';
export const AUTH_STATE_LOGIN = 'AUTH_STATE_LOGIN';
export const AUTH_STATE_LOGOUT = 'AUTH_STATE_LOGOUT';
